/*! style-injector.js */

import { version } from "build/shims";
import Log from "app/utils/log";
import LoadTimer from "app/utils/load-timer";
import ErrorReport from "app/utils/error-report";

const log = new Log("StyleInjector");

const BVP_CSS_ID = "_bvpStyle";
const LOAD_ERROR_MESSAGE = "Link could not be loaded";
const ERROR = "error";
const COMPLETE = "complete";

const StyleInjector = {
    /**
     * Injects a link on a page.
     * @param {string} uri
     * @param {string} htmlChildId the player id to track load times
     * @return {Promise}
     */
    inject(uri, htmlChildId) {

        const into = document.getElementsByTagName("head")[0];

        if (linkExists()) {
            return Promise.resolve();
        }

        return new Promise((accept, reject) => {
            LoadTimer.trackLoadStart(htmlChildId, LoadTimer.loadTypes.CSS_FILE, uri);

            let link = createLink();

            /**
             * IE10< Stylesheet load detection
             */
            if (link.onreadystatechange !== undefined) {
                link.onreadystatechange = function() {
                    if (COMPLETE === this.readyState) {
                        /**
                         * [ST] "visibility" style is set by the stylesheet to detect successful load
                         * @type {boolean}
                         */
                        const isLoaded = this.currentStyle.visibility === "hidden";

                        if (isLoaded) {
                            LoadTimer.trackLoadComplete(htmlChildId, LoadTimer.loadTypes.CSS_FILE, LoadTimer.loadStatus.COMPLETE);
                            accept();
                        } else {
                            LoadTimer.trackLoadComplete(htmlChildId, LoadTimer.loadTypes.CSS_FILE, LoadTimer.loadStatus.ERROR);
                            ErrorReport.recordLoadError(log, uri, `Error loading ${ uri }`);
                            reject(LOAD_ERROR_MESSAGE);
                        }

                        link.onreadystatechange = link = null;
                    }
                };
            } else {
                link.onload = link.onerror = function(event) {
                    if (ERROR === event.type) {
                        LoadTimer.trackLoadComplete(htmlChildId, LoadTimer.loadTypes.CSS_FILE, LoadTimer.loadStatus.ERROR);
                        ErrorReport.recordLoadError(log, uri, `Could not load style ${ uri }`);
                        reject(LOAD_ERROR_MESSAGE);
                    } else {
                        LoadTimer.trackLoadComplete(htmlChildId, LoadTimer.loadTypes.CSS_FILE, LoadTimer.loadStatus.COMPLETE);
                        accept();
                    }

                    link.onload = link.onerror = link = null;
                };
            }

            link.href = uri;
            into.appendChild(link);
        });
    }
};

/**
 * Initializes link template element
 */
function createLink() {
    const linkTemplate = document.createElement("link");

    linkTemplate.setAttribute("data-version", version);
    linkTemplate.setAttribute("id", BVP_CSS_ID);
    linkTemplate.setAttribute("rel", "stylesheet");
    linkTemplate.setAttribute("type", "text/css");

    return linkTemplate;
}

/**
 * Checks to see if link already injected on the page
 * @return {boolean}
 */
function linkExists() {
    return Boolean(document.getElementById(BVP_CSS_ID));
}

export default StyleInjector;
